const handleStickyFocus = (handleBlur, onClick) => (e) => {
    handleBlur();
    onClick && onClick(e);
};
export default handleStickyFocus;
//# sourceMappingURL=index.js.map